import { render, staticRenderFns } from "./RobotAssistantContent.vue?vue&type=template&id=4e9f4642&scoped=true&"
import script from "./RobotAssistantContent.vue?vue&type=script&lang=js&"
export * from "./RobotAssistantContent.vue?vue&type=script&lang=js&"
import style0 from "./RobotAssistantContent.vue?vue&type=style&index=0&id=4e9f4642&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9f4642",
  null
  
)

export default component.exports